import { APP_NAME, $html } from '../utils/environment';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'Map';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`,
    MOUSEENTER: `mouseenter.${EVENT_NAMESPACE}`,
    MOUSELEAVE: `mouseleave.${EVENT_NAMESPACE}`
};

const CLASS = {
    HAS_CATEGORY_HOVER: 'has-category-hover'
}

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        this.color = options.id || 'plus';

        this.hasCategories = options.categories;

        this.spritePath = 'assets/images/sprite.svg';
    }

    init() {
        if (document.documentElement.dataset.assetsVersion) {
            this.spritePath += `?v=${document.documentElement.dataset.assetsVersion}`;
        }


        this.$el.on(EVENT.CLICK, '.js-breadcrumb-header', (e) => this.toggleDropdown(e));
        this.$el.on(EVENT.CLICK, '.js-breadcrumb-main', (e) => this.stop(e));
        $('.js-scroll').on(EVENT.CLICK, () => this.closeDropdown());

        if(this.hasCategories) {
            this.$icon = $('.js-icon', this.$el);
            this.$el.on(EVENT.MOUSEENTER,'.js-breadcrumb-link',(e) => this.updateColor(e))
            this.$el.on(EVENT.MOUSELEAVE,'.js-breadcrumb-link',(e) => this.resetColor(e))
            this.$el.on(EVENT.CLICK,'.js-breadcrumb-link',(e) => {
                this.color = $(e.currentTarget).attr('data-id');
                this.updateColor(e)
            });

            this.current = $('.js-breadcrumb-link.is-current').attr('data-id');

            if(this.current === 'plus') {
                this.$el.attr('data-id', 'plus');
                this.$icon.attr('xlink:href', this.spritePath + '#calendar');
            } else {
                this.$el.attr('data-id', this.current);
                this.$icon.attr('xlink:href', this.spritePath + `#categories-${this.current}`);
            }
        }
    }

    toggleDropdown(e) {
        e.stopPropagation();

        $html.toggleClass('has-breadcrumb-open');

        if(window.innerWidth < 1000) {
            if($html.hasClass('has-breadcrumb-open')) {
                $('.js-aside').animate({ scrollTop: 0 },0);
            }
        }
    }

    closeDropdown() {
        if(window.innerWidth > 1000) {
            $html.removeClass('has-breadcrumb-open');
        }
    }

    stop(e) {
        if(!$(e.target).is('a')) {
            e.stopPropagation();
        }
    }

    updateColor(e) {
        const id = $(e.currentTarget).attr('data-id');

        if(id === 'plus') {
            this.$el.removeClass(CLASS.HAS_CATEGORY_HOVER);
            this.$icon.attr('xlink:href', this.spritePath + '#calendar');
        } else {
            this.$el.addClass(CLASS.HAS_CATEGORY_HOVER);
            this.$icon.attr('xlink:href', this.spritePath + `#categories-${id}`);
        }

        this.$el.attr('data-id', id);
    }

    resetColor(e) {
        if(!$html.hasClass('has-dom-loading')) {
            let id = this.color;

            if(id === 'plus') {
                this.$el.removeClass(CLASS.HAS_CATEGORY_HOVER);
                this.$icon.attr('xlink:href', this.spritePath + '#calendar');
            } else {
                this.$el.addClass(CLASS.HAS_CATEGORY_HOVER);
                this.$icon.attr('xlink:href', this.spritePath + `#categories-${id}`);
            }

            this.$el.attr('data-id', id);
        }
    }

    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
        $('.js-scroll').off(`.${EVENT_NAMESPACE}`);
    }
}
